import { memo } from 'react';
import { CallCardAttachmentsGrid } from '@/components/callcard/CallCardAttachmentsGrid';

interface CallCardAttachmentsTabProps {
  attachments: any[];
  isReadOnly: boolean;
  onUpload: (fileInput: HTMLInputElement) => void;
  onRemove: (attachment: any) => void;
}

export const CallCardAttachmentsTab = memo(function CallCardAttachmentsTab({
  attachments,
  isReadOnly,
  onUpload,
  onRemove,
}: CallCardAttachmentsTabProps) {
  return (
    <div className="tab-content-panel">
      <CallCardAttachmentsGrid
        attachments={attachments}
        isReadOnly={isReadOnly}
        onUpload={onUpload}
        onRemove={onRemove}
      />
    </div>
  );
});
